<div class="item-panel">
	<div class="heading strong"><b>ROTOR TRACK + BALANCE</b></div>
	<div *ngIf="rotors && rotors.length">
		<div class="content">
			<div class="row">
				<label class="col-md-2 col-form-label">Rotor:</label>
				<div class="col-md-4">
					<select class="form-control form-control-sm" [ngModel]="selectedRotor" (ngModelChange)="rotorChange($event)">
						<option *ngFor="let rotor of rotors" [ngValue]="rotor">{{rotor.name}}</option>
					</select>
				</div>
			</div>
		</div>
		<div class="content nopad">
			<div *ngIf="selectedRotor">
				<ul ngbNav #nav="ngbNav" class="nav-tabs dark">
					<li ngbNavItem ngbNavItem="tab-rotorvibe">
						<a ngbNavLink>Rotor Vibration</a>
						<ng-template ngbNavContent>
							<app-rtb-balance [asset]="asset" [fleet]="fleet" [rotor]="selectedRotor" [regimeConfigs]="regimes" (recordAdjustment)="RecordAdjustment($event)"></app-rtb-balance>
						</ng-template>
					</li>
					<li ngbNavItem ngbNavItem="tab-rotortrack">
						<a ngbNavLink>Rotor Track</a>
						<ng-template ngbNavContent>
							<app-rtb-track [asset]="asset" [fleet]="fleet" [rotor]="selectedRotor" [regimeConfigs]="regimes" (recordAdjustment)="RecordAdjustment($event)"></app-rtb-track>
						</ng-template>
					</li>
					<li ngbNavItem *ngIf="vibecheck" ngbNavItem="tab-vibecheck">
						<a ngbNavLink [class.status-warning-fg]="(vibecheckstatus | hilevel) === 3" [class.status-error-fg]="(vibecheckstatus | hilevel) === 4">Vibration Checks</a>
						<ng-template ngbNavContent>
							<app-vibe-check [asset]="asset" [fleet]="fleet" [vibecheck]="vibecheck"></app-vibe-check>
						</ng-template>
					</li>
					<li ngbNavItem ngbNavItem="tab-adjustment-history">
						<a ngbNavLink>Vibration / Adjustment History</a>
						<ng-template ngbNavContent>
							<app-adjustment-history [asset]="asset" [fleet]="fleet" [rotor]="selectedRotor" [archive]="adjustmentArchive" [regimeConfigs]="regimes"></app-adjustment-history>
						</ng-template>
					</li>
					<li ngbNavItem ngbNavItem="tab-track-history">
						<a ngbNavLink>Track History</a>
						<ng-template ngbNavContent>
							<app-track-history [asset]="asset" [fleet]="fleet" [rotor]="selectedRotor" [regimeConfigs]="regimes">
							</app-track-history>
						</ng-template>
					</li>
					<li ngbNavItem *ngIf="api.user?.role === 'admin' || api.user?.role === 'master'" ngbNavItem="tab-vibe-coefficients">
						<a ngbNavLink>Vibe Coefficients</a>
						<ng-template ngbNavContent>
							<app-rtb-coefficients [asset]="asset" [fleet]="fleet" [rotor]="selectedRotor" [regimeConfigs]="regimes"></app-rtb-coefficients>
						</ng-template>
					</li>
					<li ngbNavItem *ngIf="api.user?.role === 'admin' || api.user?.role === 'master'" ngbNavItem="tab-track-coefficients">
						<a ngbNavLink>Track Coefficients</a>
						<ng-template ngbNavContent>
							<app-track-coefficients [asset]="asset" [fleet]="fleet" [rotor]="selectedRotor" [regimeConfigs]="regimes">
							</app-track-coefficients>
						</ng-template>
					</li>
				</ul>
				<div [ngbNavOutlet]="nav"></div>
			</div>
		</div>
	</div>
</div>